import { useNavigate } from 'react-router-dom'
import { CheckIcon } from '@heroicons/react/solid'
import {
  Anchor,
  ErrorNotLoggedIn,
  Paragraph,
  StickyFooter,
  Title,
} from 'src/components'
import { getEnvString } from 'src/utils'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { savedTokens } from 'src/auth'

export default function Finish() {
  const navigate = useNavigate()
  const iosUrl = getEnvString('REACT_APP_IOS_APP')
  const androidUrl = getEnvString('REACT_APP_ANDROID_APP')
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return (
    <div className="grid items-center gap-6">
      <Title label="FINISH" />
      <Paragraph className="col-span-full">
        We've successfully completed your setup. Once you have downloaded the{' '}
        app, you can login with your organisation name{' '}
        <b>{tokens.organization}</b> and your Amazon Connect credentials or via
        your SSO setup.
      </Paragraph>

      <Paragraph>
        Everything is now set up, you can send the following links to users to
        download the app from the app stores. Once they install the app, they
        can login by using the login method chosen by you.
      </Paragraph>

      <div>
        <Paragraph>
          iOS:
          <Anchor href={iosUrl} className="ml-2" target="_blank">
            {iosUrl}
          </Anchor>
        </Paragraph>
        <Paragraph>
          Android:
          <Anchor href={androidUrl} className="ml-2" target="_blank">
            {androidUrl}
          </Anchor>
        </Paragraph>
      </div>

      <Paragraph>
        To enable contact searching within the app, you'll need to add the
        following <b>view permissions</b> to the <b>agent profile</b> in{' '}
        <b>Amazon Connect</b>
      </Paragraph>

      <ul className="text-secondary ml-4 list-disc">
        <li>Contact Search</li>
        <li>Search contacts by keywords</li>
        <li>Contact attributes</li>
      </ul>

      <StickyFooter className="justify-start">
        <CustomButton
          type="button"
          label="Go to admin portal"
          icon={<CheckIcon />}
          iconSize={5}
          iconColor="text-white"
          iconPosition="left"
          onClick={() => {
            navigate('../../')
          }}
          className="text-lg text-white bg-accent-foreground hover:text-white hover:shadow-lg focus:shadow-lg"
          size="lg"
        />
      </StickyFooter>
    </div>
  )
}
